import React from "react";
import { useNavigate } from "react-router-dom";
import IconAccountCircle from "../../Teacher/Layout/NavigationDrawer/Icons/IconAccountCircle";
import IconUser from "../Icons/IconUser";
import packageJson from "../../../package.json";

interface SelectLoginPageProps {
  showSuccessfulEmailConfirmed?: boolean;
}

export default function SelectLoginPage(props: SelectLoginPageProps) {
  const navigate = useNavigate();

  return (
    <div className="w-full h-full inline-flex flex-col px-2.5 pt-12 pb-2.5 gap-6 overflow-clip overscroll-none bg-center bg-[url(https://uortjlczjmucmpaqqhqm.supabase.co/storage/v1/object/public/firejet-converted-images/6550/8ed16c7d87439ffb6cfe6d05fb8a5e28c640b204.webp)] bg-cover">
      <div className="fixed bottom-2 left-2 text-[12px] text-gray-300 select-none pointer-events-none">
        v{packageJson.version}
      </div>
      {props.showSuccessfulEmailConfirmed && (
        <p className="text-center font-['Poppins'] pb-4 text-2xl font-medium leading-[1.4] text-[rgba(109,109,109,1)]">
          Email Confirmation Success!
        </p>
      )}
      <p className="text-center font-['Poppins'] text-xl font-medium leading-[1.4] text-[rgba(109,109,109,1)]">
        Log In for:
      </p>
      <div className="w-full flex flex-wrap gap-6 justify-center items-start">
        <div
          className="hover:scale-105 transition ease-in-out  w-[220px] h-[180px] flex flex-col items-center justify-center gap-3 rounded-3xl bg-[rgba(255,254,252,1)] py-12 pl-[116px] pr-[116px] drop-shadow-lg cursor-pointer"
          onClick={() => {
            navigate("/teacher/login");
          }}
        >
          <div className="w-[64px] h-[64px] fill-brij-Red">
            <IconAccountCircle />
          </div>
          <div className="flex w-full items-end justify-center gap-2.5 p-1.5">
            <p className="text-right font-['Poppins'] text-xl font-medium leading-[1.4] text-[rgba(109,109,109,1)]">
              Teacher
            </p>
          </div>
        </div>
        <div
          className="hover:scale-105 transition ease-in-out  w-[220px] h-[180px] flex flex-col items-center justify-center gap-3 rounded-3xl bg-[rgba(255,254,252,1)] py-12 pl-[116px] pr-[116px] drop-shadow-lg cursor-pointer"
          onClick={() => {
            navigate("/parent/login");
          }}
        >
          <div className="w-[64px] h-[64px] fill-brij-Blue">
            <IconAccountCircle />
          </div>
          <div className="flex w-full items-end justify-center gap-2.5 p-1.5 ">
            <p className="text-right font-['Poppins'] text-xl font-medium leading-[1.4] text-[rgba(109,109,109,1)]">
              Parent/Student
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
